import React, { useState } from 'react'
import { Row, Col } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const Batsmen = ({ score, viewport, fontSize }) => {

    // this code refers if match was complete it show next match data
    const progress = score.matchHeader?.state
    var matchCompleted = false
    if (progress == "Complete") {
        matchCompleted = true
    } else {
        matchCompleted = false
    }

    // this total code refers reload icon when 
    if (!score.miniscore) {
        return <Row justify={'center'} >
            <Col xs={viewport.xs} sm={viewport.sm - 1} lg={viewport.lg - 1}>
                <Row>
                    {progress !== 'Preview' && <LoadingOutlined className='loadingIcon' />}
                </Row>
            </Col>
        </Row>
    }

    //this is batman stricker
    const batmanName = score.miniscore.batsmanStriker.name ? score.miniscore.batsmanStriker.name : '-'
    const batmanRun = score.miniscore.batsmanStriker.runs
    const batmanBall = score.miniscore.batsmanStriker.balls
    const batmanFour = score.miniscore.batsmanStriker.fours
    const batmanSix = score.miniscore.batsmanStriker.sixes
    const batmanStrikeRate = score.miniscore.batsmanStriker.strikeRate

    //this is batman non striker
    const nonbatmanName = score.miniscore.batsmanNonStriker.name
    const nonbatmanRun = score.miniscore.batsmanNonStriker.runs
    const nonbatmanBall = score.miniscore.batsmanNonStriker.balls
    const nonbatmanFour = score.miniscore.batsmanNonStriker.fours
    const nonbatmanSix = score.miniscore.batsmanNonStriker.sixes
    const nonbatmanStrikeRate = score.miniscore.batsmanNonStriker.strikeRate

    //this bowler 
    const bowlername = score.miniscore.bowlerStriker.name
    const bowlerovers = score.miniscore.bowlerStriker.overs
    const bowlermaiden = score.miniscore.bowlerStriker.maidens
    const bowlerruns = score.miniscore.bowlerStriker.runs
    const bowlerWicket = score.miniscore.bowlerStriker.wickets
    const bowlerEconomy = score.miniscore.bowlerStriker.economy

    //this is non stricker name
    const nonbowlername = score.miniscore.bowlerNonStriker.name
    const nonbowlerovers = score.miniscore.bowlerNonStriker.overs
    const nonbowlermaiden = score.miniscore.bowlerNonStriker.maidens
    const nonbowlerruns = score.miniscore.bowlerNonStriker.runs
    const nonbowlerWicket = score.miniscore.bowlerNonStriker.wickets
    const nonbowlerEconomy = score.miniscore.bowlerNonStriker.economy


    return (
        <div className='batsmen'>
            <Row justify={'space-around'}>
                <Col xs={viewport.xs} sm={viewport.sm - 1} lg={viewport.lg - 1} style={fontSize}>
                    <table className='batter_bowler_table'>
                        <thead>
                            <tr className='heads'>
                                <th>Batting </th>
                                <th>R</th>
                                <th>B</th>
                                <th>4s</th>
                                <th>6s</th>
                                <th>SR</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td><b>{batmanName ? `${batmanName} *` : '-'}</b> </td>
                                <td>{batmanRun}</td>
                                <td>{batmanBall}</td>
                                <td>{batmanFour} </td>
                                <td>{batmanSix}</td>
                                <td>{batmanStrikeRate}</td>
                            </tr>
                            <tr>
                                <td><b>{nonbatmanName ? nonbatmanName : '-'}</b></td>
                                <td>{nonbatmanRun}</td>
                                <td>{nonbatmanBall}</td>
                                <td>{nonbatmanFour}</td>
                                <td>{nonbatmanSix}</td>
                                <td>{nonbatmanStrikeRate}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table className='batter_bowler_table'>
                        <thead>
                            <tr className='heads'>
                                <th>Bowling</th>
                                <th>O</th>
                                <th>M</th>
                                <th>R</th>
                                <th>W</th>
                                <th>ECO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>{bowlername ? `${bowlername} * ` : '-'}</b> </td>
                                <td>{bowlerovers} </td>
                                <td>{bowlermaiden}</td>
                                <td>{bowlerruns}</td>
                                <td>{bowlerWicket}</td>
                                <td>{bowlerEconomy}</td>
                            </tr>
                            {bowlerovers ?
                                <tr>
                                    <td><b>{nonbowlername ? nonbowlername : '-'}</b></td>
                                    <td>{nonbowlerovers}</td>
                                    <td>{nonbowlermaiden}</td>
                                    <td>{nonbowlerruns}</td>
                                    <td>{nonbowlerWicket}</td>
                                    <td>{nonbowlerEconomy}</td>
                                </tr>
                                : null}

                        </tbody>

                    </table>
                </Col>
            </Row>
        </div>

    )
}

export default Batsmen